import {
    Button, Checkbox,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, FormControlLabel,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    useTheme
} from "@mui/material";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import IconButton from "@mui/material/IconButton";
import dayjs from "dayjs";
import {useProductCodeActions} from "../../../service/useProductCodeActions";
import {useStatusValuesBusinessAgreement} from "../../../component/useStatusValuesBusinessAgreement";
import {useStatusValuesProduct} from "../../../component/useStatusValuesProduct";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import {
    UserLegalEntitiesOrDealersInputGroup
} from "../../../component/UserLegalEntitiesOrDealersInputGroup/UserLegalEntitiesOrDealersInputGroup";
import TaxConfigurationDetail from "../../../component/TaxConfiguration/TaxConfigurationDetail";
import OrderConfigurationDetail from "../accordion/OrderConfigurationDetail";
import {stringToBool} from "../../../component/Utils";
import { DEPOSIT_CODES_LIST } from "../../../service/SalesMarketingRecoil";
import { useRecoilState } from "recoil";

const BusinessAgreementDetailModal = (props: any) => {
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'businessAgreement'});

    const {getStatusLabelAgreement} = useStatusValuesBusinessAgreement();
    const {getStatusColorProduct, getStatusLabelProduct} = useStatusValuesProduct();

    const theme = useTheme();
    const {businessAgreement} = props;
    const {
        listSegment,
        listGuaranteeSchemes,
        listPaymentDueDates,
        listBillingModes,
        listInvoiceRecipients,
        listPaymentMethods
    } = useProductCodeActions();
    const [segments, setSegments] = useState<any[]>([]);
    const [guarantee, setGuarantee] = useState<any[]>([]);
    const [paymentDueDates, setPaymentDueDates] = useState<any[]>([]);
    const [billingModes, setBillingModes] = useState<any[]>([]);
    const [invoiceRecipients, setInvoiceRecipients] = useState<any[]>([]);
    const [paymentMethods, setPaymentMethods] = useState<any[]>([]);
    const [depositList] = useRecoilState(DEPOSIT_CODES_LIST);
    const {getPreAuthorizationList} = useProductCodeActions();

    useEffect(() => {
        if (businessAgreement) {
            const segmentPromise = listSegment();
            const guaranteePromise = listGuaranteeSchemes(businessAgreement.tenantId, businessAgreement.dealerId);
            const paymentDueDatesPromise = listPaymentDueDates(businessAgreement.tenantId, businessAgreement.dealerId);
            const billingModesPromise = listBillingModes();
            const invoiceRecipientsPromise = listInvoiceRecipients();
            const paymentMethodsPromise = listPaymentMethods(businessAgreement.tenantId, businessAgreement.dealerId);
            const preAuthCodesPromise = getPreAuthorizationList(businessAgreement.tenantId, businessAgreement.dealerId);
            Promise.allSettled([segmentPromise, guaranteePromise, paymentDueDatesPromise, billingModesPromise, invoiceRecipientsPromise, paymentMethodsPromise,preAuthCodesPromise]).then(res => {
                if (res[0].status === 'fulfilled') setSegments(res[0].value);
                if (res[1].status === 'fulfilled') setGuarantee(res[1].value);
                if (res[2].status === 'fulfilled') setPaymentDueDates(res[2].value);
                if (res[3].status === 'fulfilled') setBillingModes(res[3].value);
                if (res[4].status === 'fulfilled') setInvoiceRecipients(res[4].value);
                if (res[5].status === 'fulfilled') setPaymentMethods(res[5].value);
            })
        }
    }, [businessAgreement])


    return (
        businessAgreement &&
        <Dialog scroll={"paper"} maxWidth={"lg"} disableEscapeKeyDown fullWidth={true} open={props.open}
                onClose={() => {
                    return;
                }}>
            <DialogTitle>
                <Typography fontWeight={"bold"} color={"primary"}>
                    {t('details')}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => {
                        props.handleClose();
                    }}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseRoundedIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} sx={{padding: "15px"}} alignItems={'flex-end'}>
                    <UserLegalEntitiesOrDealersInputGroup tenantId={businessAgreement.tenantId}
                                                          dealerId={businessAgreement.dealerId}/>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="status"
                            label={t('businessCode')}
                            fullWidth
                            variant="standard"
                            value={businessAgreement.businessCode}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={9}/>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="status"
                            label={t('status')}
                            fullWidth
                            variant="standard"
                            value={getStatusLabelAgreement(businessAgreement.status)}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={9}/>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="customerId"
                            label={t('customerId')}
                            fullWidth
                            variant="standard"
                            value={businessAgreement.customerId}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="customerName"
                            label={t('customerName')}
                            fullWidth
                            variant="standard"
                            value={businessAgreement.customerName}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="personName"
                            label={t('personName')}
                            fullWidth
                            variant="standard"
                            value={businessAgreement?.personName ? businessAgreement.personName : ""}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="personSurname"
                            label={t('personSurname')}
                            fullWidth
                            variant="standard"
                            value={businessAgreement?.personSurname ? businessAgreement.personSurname : ""}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="segment"
                            label={t('segment')}
                            fullWidth
                            variant="standard"
                            value={segments.length > 0 ? segments.find(s => s.segmentCode === businessAgreement.segmentCode)?.segmentName : ""}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="startDate"
                            label={t('startDate')}
                            fullWidth
                            variant="standard"
                            value={businessAgreement.configStartDate ? dayjs(businessAgreement.configStartDate).format("L") : null}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="endDate"
                            label={t('endDate')}
                            fullWidth
                            variant="standard"
                            value={businessAgreement.configEndDate ? dayjs(businessAgreement.configEndDate).format("L") : null}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="name"
                            label={t('name')}
                            fullWidth
                            variant="standard"
                            value={businessAgreement.name}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="description"
                            label={t('description')}
                            fullWidth
                            variant="standard"
                            value={businessAgreement.description}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="rentalGroup"
                            label={t('rentalGroup')}
                            fullWidth
                            variant="standard"
                            value={businessAgreement.rentalGroup === -1 ? t('unlimitedRentalGroup') : businessAgreement.rentalGroup}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="deposit"
                            label={t('deposit')}
                            fullWidth
                            variant="standard"
                            value={depositList.find(authCode => authCode.id === businessAgreement.preAuthCode)?.description ?? ''}
                            inputProps={
                                {readOnly: true}
                            }
                            InputLabelProps={{shrink: true}}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="vendorId"
                            label={t('vendorId')}
                            fullWidth
                            variant="standard"
                            value={businessAgreement.vendorId}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="procurerId"
                            label={t('procurerId')}
                            fullWidth
                            variant="standard"
                            value={businessAgreement.procurerId}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            margin="dense"
                            id="emailCourtesyInvoice"
                            label={t('emailCourtesyInvoice')}
                            fullWidth
                            variant="standard"
                            value={businessAgreement.emailCourtesyInvoice.join(" - ")}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            margin="dense"
                            id="accountEmail"
                            label={t('accountEmail')}
                            fullWidth
                            variant="standard"
                            value={businessAgreement.accountEmail.join(" - ")}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            name="emailSendingVoucher"
                            label={t('emailSendingVoucher')}
                            value={businessAgreement.emailSendingVoucher}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="guarantee"
                            label={t('guarantee')}
                            fullWidth
                            variant="standard"
                            value={guarantee.length > 0 ? guarantee.find(s => s.value === businessAgreement.guarantee)?.label : ""}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="paymentMethod"
                            label={t('paymentMethod')}
                            fullWidth
                            variant="standard"
                            value={paymentMethods.length > 0 ? paymentMethods.find(s => s.value === businessAgreement.paymentMethod)?.label : ""}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="paymentDueDate"
                            label={t('paymentDueDate')}
                            fullWidth
                            variant="standard"
                            value={paymentDueDates.length > 0 ? paymentDueDates.find(s => s.value === businessAgreement.paymentDueDate)?.label : ""}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="billingMode"
                            label={t('billingMode')}
                            fullWidth
                            variant="standard"
                            value={billingModes.length > 0 ? billingModes.find(s => s.value === businessAgreement.billingMode)?.label : ""}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="firstInvoiceRecipient"
                            label={t('firstInvoiceRecipient')}
                            fullWidth
                            variant="standard"
                            value={invoiceRecipients.length > 0 ? invoiceRecipients.find(s => s.id === businessAgreement.firstInvoiceRecipient)?.recipientType : ""}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="subsequenceInvoiceRecipient"
                            label={t('subsequenceInvoiceRecipient')}
                            fullWidth
                            variant="standard"
                            value={invoiceRecipients.length > 0 ? invoiceRecipients.find(s => s.id === businessAgreement.subsequentInvoiceRecipient)?.recipientType : ""}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="dossier"
                            label={t('dossier')}
                            fullWidth
                            variant="standard"
                            value={getStatusLabelAgreement(businessAgreement.dossier)}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <FormControlLabel
                            label={t('splitPayment')}
                            control={<Checkbox
                                color={"accent"}
                                sx={{color: theme.palette.accent.main}}
                                checked={businessAgreement.splitPayment ? stringToBool(businessAgreement.splitPayment) : false}
                            />}
                        />
                    </Grid>
                    {businessAgreement.taxConfiguration &&
                        <Grid item xs={12} sx={{marginTop: '50px'}}>
                            <TaxConfigurationDetail taxConfiguration={businessAgreement.taxConfiguration}/>
                        </Grid>
                    }
                    {businessAgreement.orderConfiguration &&
                        <Grid item xs={12} sx={{marginTop: '32px'}}>
                            <OrderConfigurationDetail orders={businessAgreement.orderConfiguration}/>
                        </Grid>
                    }
                </Grid>
                {businessAgreement.productList && businessAgreement.productList.length > 0 &&
                    <Grid container spacing={2} sx={{padding: "15px"}} alignItems={"center"}>
                        <Grid item>
                            <Typography>{t('products.title')}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <TableContainer>
                                <Table aria-label="productList-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>{t('products.name')}</TableCell>
                                            <TableCell>{t('products.code')}</TableCell>
                                            <TableCell>{t('products.startDate')}</TableCell>
                                            <TableCell>{t('products.endDate')}</TableCell>
                                            <TableCell>{t('products.category')}</TableCell>
                                            <TableCell>{t('products.jimpyCode')}</TableCell>
                                            <TableCell>{t('products.status')}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {businessAgreement.productList.map((row: any, index: number) => (
                                            <TableRow
                                                key={"prd" + index}
                                            >
                                                <TableCell>{row.productName ? row.productName : ""}</TableCell>
                                                <TableCell>{row.productCode ? row.productCode : ""}</TableCell>
                                                <TableCell>{row.startDate ? dayjs(row.startDate).format("L") : ""}</TableCell>
                                                <TableCell>{row.endDate ? dayjs(row.endDate).format("L") : ""}</TableCell>
                                                <TableCell>{row.category ? row.category : ""}</TableCell>
                                                <TableCell>{row.jimpyCode ? row.jimpyCode : ""}</TableCell>
                                                <TableCell>{row.status ?
                                                    <Chip label={getStatusLabelProduct(row.status)}
                                                          sx={{backgroundColor: getStatusColorProduct(row.status)}}/>
                                                    : ""}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                }
            </DialogContent>
            <DialogActions style={{backgroundColor: theme.palette.neutral.main}}>
                <Button color={"accent"}
                        onClick={() => props.handleClose()}>{t('buttons.close')}</Button>
            </DialogActions>
        </Dialog>
    )
}

export default BusinessAgreementDetailModal;